import { Form } from 'react-bootstrap';

/**
 * Composite "TYPE:id" single-select over Warehouses/Retail Stores/Production Units.
 * `restrictToType`, when set to WAREHOUSE/RETAIL_STORE/PRODUCTION_UNIT, hides the other two
 * optgroups (used to enforce a Goods Movement Type's locationType restriction).
 */
function LocationSelect({ value, onChange, warehouses, retailStores, productionUnits, required = true, id, restrictToType }) {
  const activeWarehouses = restrictToType && restrictToType !== 'WAREHOUSE' ? [] : (warehouses || []).filter((w) => w.isActive !== false);
  const activeRetailStores = restrictToType && restrictToType !== 'RETAIL_STORE' ? [] : (retailStores || []).filter((rs) => rs.isActive !== false);
  const activeProductionUnits = restrictToType && restrictToType !== 'PRODUCTION_UNIT' ? [] : (productionUnits || []).filter((pu) => pu.isActive !== false);
  return (
    <Form.Select id={id} value={value} onChange={onChange} required={required}>
      <option value="">Select Location</option>
      {activeWarehouses.length > 0 && (
        <optgroup label="Warehouses">
          {activeWarehouses.map((wh) => (
            <option key={`WAREHOUSE:${wh.id}`} value={`WAREHOUSE:${wh.id}`}>{wh.name}</option>
          ))}
        </optgroup>
      )}
      {activeRetailStores.length > 0 && (
        <optgroup label="Retail Stores">
          {activeRetailStores.map((rs) => (
            <option key={`RETAIL_STORE:${rs.id}`} value={`RETAIL_STORE:${rs.id}`}>{rs.name}</option>
          ))}
        </optgroup>
      )}
      {activeProductionUnits.length > 0 && (
        <optgroup label="Production Units">
          {activeProductionUnits.map((pu) => (
            <option key={`PRODUCTION_UNIT:${pu.id}`} value={`PRODUCTION_UNIT:${pu.id}`}>{pu.name}</option>
          ))}
        </optgroup>
      )}
    </Form.Select>
  );
}

export default LocationSelect;
